export const ember = {
  '50': 'rgb(34, 39, 43)',
  '100': 'rgb(28, 42, 59)',
  '150': 'rgb(28, 42, 76)',
  '200': 'rgb(37, 38, 92)',
  '250': 'rgb(51, 31, 104)',
  '300': 'rgb(68, 17, 112)',
  '350': 'rgb(97, 17, 117)',
  '400': 'rgb(128, 15, 115)',
  '450': 'rgb(159, 9, 106)',
  '500': 'rgb(188, 7, 88)',
  '550': 'rgb(215, 21, 58)',
  '600': 'rgb(222, 43, 52)',
  '650': 'rgb(228, 59, 46)',
  '700': 'rgb(233, 73, 39)',
  '750': 'rgb(238, 86, 33)',
  '800': 'rgb(243, 99, 27)',
  '850': 'rgb(247, 115, 0)',
  '900': 'rgb(249, 130, 0)',
  '950': 'rgb(251, 145, 0)',
  '1000': 'rgb(251, 160, 0)',
  '1050': 'rgb(250, 175, 5)',
}
export const earthfire = {
  '50': 'rgb(82, 55, 25)',
  '100': 'rgb(95, 54, 13)',
  '150': 'rgb(108, 51, 0)',
  '200': 'rgb(122, 46, 0)',
  '250': 'rgb(135, 38, 0)',
  '300': 'rgb(148, 27, 0)',
  '350': 'rgb(167, 42, 5)',
  '400': 'rgb(185, 56, 11)',
  '450': 'rgb(204, 70, 17)',
  '500': 'rgb(224, 85, 22)',
  '550': 'rgb(243, 99, 27)',
  '600': 'rgb(247, 115, 0)',
  '650': 'rgb(249, 130, 0)',
  '700': 'rgb(251, 145, 0)',
  '750': 'rgb(251, 160, 0)',
  '800': 'rgb(250, 175, 5)',
  '850': 'rgb(250, 187, 59)',
  '900': 'rgb(250, 199, 87)',
  '950': 'rgb(251, 210, 111)',
  '1000': 'rgb(252, 221, 133)',
  '1050': 'rgb(253, 231, 154)',
}
export const fuchsiaHeat = {
  '50': 'rgb(101, 0, 77)',
  '100': 'rgb(123, 2, 95)',
  '150': 'rgb(146, 4, 114)',
  '200': 'rgb(169, 8, 133)',
  '250': 'rgb(193, 13, 153)',
  '300': 'rgb(217, 18, 174)',
  '350': 'rgb(230, 30, 146)',
  '400': 'rgb(240, 45, 119)',
  '450': 'rgb(245, 62, 91)',
  '500': 'rgb(246, 80, 62)',
  '550': 'rgb(243, 99, 27)',
  '600': 'rgb(247, 115, 0)',
  '650': 'rgb(249, 130, 0)',
  '700': 'rgb(251, 145, 0)',
  '750': 'rgb(251, 160, 0)',
  '800': 'rgb(250, 175, 5)',
  '850': 'rgb(250, 187, 59)',
  '900': 'rgb(250, 199, 87)',
  '950': 'rgb(251, 210, 111)',
  '1000': 'rgb(252, 221, 133)',
  '1050': 'rgb(253, 231, 154)',
}
export const polarGlow = {
  '50': 'rgb(0, 38, 100)',
  '100': 'rgb(1, 51, 128)',
  '150': 'rgb(3, 65, 158)',
  '200': 'rgb(7, 79, 189)',
  '250': 'rgb(13, 93, 220)',
  '300': 'rgb(20, 108, 253)',
  '350': 'rgb(0, 119, 231)',
  '400': 'rgb(0, 126, 208)',
  '450': 'rgb(0, 130, 184)',
  '500': 'rgb(0, 130, 162)',
  '550': 'rgb(46, 128, 142)',
  '600': 'rgb(66, 146, 159)',
  '650': 'rgb(84, 163, 176)',
  '700': 'rgb(103, 182, 193)',
  '750': 'rgb(121, 200, 211)',
  '800': 'rgb(140, 219, 229)',
  '850': 'rgb(154, 223, 229)',
  '900': 'rgb(169, 227, 229)',
  '950': 'rgb(182, 231, 230)',
  '1000': 'rgb(196, 235, 231)',
  '1050': 'rgb(209, 238, 234)',
}
export const glacierPool = {
  '50': 'rgb(68, 17, 112)',
  '100': 'rgb(81, 30, 136)',
  '150': 'rgb(93, 43, 161)',
  '200': 'rgb(106, 57, 187)',
  '250': 'rgb(117, 70, 214)',
  '300': 'rgb(128, 85, 241)',
  '350': 'rgb(115, 89, 246)',
  '400': 'rgb(100, 94, 250)',
  '450': 'rgb(83, 98, 252)',
  '500': 'rgb(60, 103, 253)',
  '550': 'rgb(20, 108, 253)',
  '600': 'rgb(0, 137, 255)',
  '650': 'rgb(12, 162, 255)',
  '700': 'rgb(59, 185, 255)',
  '750': 'rgb(100, 205, 255)',
  '800': 'rgb(140, 224, 255)',
  '850': 'rgb(154, 227, 255)',
  '900': 'rgb(167, 229, 255)',
  '950': 'rgb(179, 232, 254)',
  '1000': 'rgb(191, 234, 254)',
  '1050': 'rgb(203, 237, 253)',
}
export const deepCurrent = {
  '50': 'rgb(11, 63, 71)',
  '100': 'rgb(18, 75, 84)',
  '150': 'rgb(25, 88, 98)',
  '200': 'rgb(32, 101, 113)',
  '250': 'rgb(39, 114, 127)',
  '300': 'rgb(46, 128, 142)',
  '350': 'rgb(0, 130, 162)',
  '400': 'rgb(0, 130, 184)',
  '450': 'rgb(0, 126, 208)',
  '500': 'rgb(0, 119, 231)',
  '550': 'rgb(20, 108, 253)',
  '600': 'rgb(0, 137, 255)',
  '650': 'rgb(12, 162, 255)',
  '700': 'rgb(59, 185, 255)',
  '750': 'rgb(100, 205, 255)',
  '800': 'rgb(140, 224, 255)',
  '850': 'rgb(154, 227, 255)',
  '900': 'rgb(167, 229, 255)',
  '950': 'rgb(179, 232, 254)',
  '1000': 'rgb(191, 234, 254)',
  '1050': 'rgb(203, 237, 253)',
}
export const blueRed = {
  '50': 'rgb(0, 38, 100)',
  '100': 'rgb(1, 51, 128)',
  '150': 'rgb(3, 65, 158)',
  '200': 'rgb(7, 79, 189)',
  '250': 'rgb(13, 93, 220)',
  '300': 'rgb(20, 108, 253)',
  '350': 'rgb(76, 142, 255)',
  '400': 'rgb(121, 172, 255)',
  '450': 'rgb(165, 200, 255)',
  '500': 'rgb(210, 228, 255)',
  '550': 'rgb(254, 215, 214)',
  '600': 'rgb(249, 175, 174)',
  '650': 'rgb(241, 134, 135)',
  '700': 'rgb(229, 89, 97)',
  '750': 'rgb(215, 21, 58)',
  '800': 'rgb(191, 15, 52)',
  '850': 'rgb(167, 10, 45)',
  '900': 'rgb(143, 5, 39)',
  '950': 'rgb(121, 2, 32)',
  '1000': 'rgb(99, 0, 25)',
}
export const blueOrange = {
  '50': 'rgb(0, 38, 100)',
  '100': 'rgb(1, 51, 128)',
  '150': 'rgb(3, 65, 158)',
  '200': 'rgb(7, 79, 189)',
  '250': 'rgb(13, 93, 220)',
  '300': 'rgb(20, 108, 253)',
  '350': 'rgb(76, 142, 255)',
  '400': 'rgb(121, 172, 255)',
  '450': 'rgb(165, 200, 255)',
  '500': 'rgb(210, 228, 255)',
  '550': 'rgb(255, 226, 214)',
  '600': 'rgb(255, 196, 173)',
  '650': 'rgb(254, 166, 131)',
  '700': 'rgb(250, 134, 87)',
  '750': 'rgb(243, 99, 27)',
  '800': 'rgb(224, 85, 22)',
  '850': 'rgb(204, 70, 17)',
  '900': 'rgb(185, 56, 11)',
  '950': 'rgb(167, 42, 5)',
  '1000': 'rgb(148, 27, 0)',
}
export const purpleYellow = {
  '50': 'rgb(68, 17, 112)',
  '100': 'rgb(81, 30, 136)',
  '150': 'rgb(93, 43, 161)',
  '200': 'rgb(106, 57, 187)',
  '250': 'rgb(117, 70, 214)',
  '300': 'rgb(128, 85, 241)',
  '350': 'rgb(150, 123, 247)',
  '400': 'rgb(174, 158, 251)',
  '450': 'rgb(199, 191, 254)',
  '500': 'rgb(227, 223, 255)',
  '550': 'rgb(255, 240, 218)',
  '600': 'rgb(255, 224, 180)',
  '650': 'rgb(254, 208, 139)',
  '700': 'rgb(252, 192, 93)',
  '750': 'rgb(250, 175, 5)',
  '800': 'rgb(219, 153, 3)',
  '850': 'rgb(189, 132, 2)',
  '900': 'rgb(160, 111, 1)',
  '950': 'rgb(132, 91, 0)',
  '1000': 'rgb(105, 72, 0)',
}
export const fuchsiaTeal = {
  '50': 'rgb(101, 0, 77)',
  '100': 'rgb(123, 2, 95)',
  '150': 'rgb(146, 4, 114)',
  '200': 'rgb(169, 8, 133)',
  '250': 'rgb(193, 13, 153)',
  '300': 'rgb(217, 18, 174)',
  '350': 'rgb(230, 91, 191)',
  '400': 'rgb(240, 136, 207)',
  '450': 'rgb(248, 177, 223)',
  '500': 'rgb(253, 216, 239)',
  '550': 'rgb(214, 229, 232)',
  '600': 'rgb(174, 203, 209)',
  '650': 'rgb(134, 178, 186)',
  '700': 'rgb(93, 153, 164)',
  '750': 'rgb(46, 128, 142)',
  '800': 'rgb(39, 114, 127)',
  '850': 'rgb(32, 101, 113)',
  '900': 'rgb(25, 88, 98)',
  '950': 'rgb(18, 75, 84)',
  '1000': 'rgb(11, 63, 71)',
}
